import usePrivateAxios from "@/common/api/usePrivateAxios";
import { defaultTransformerResponse } from "@/common/constants/defaultTransformerResponse.constant";
import { Mapper } from "@/common/services/mapper";
import { MetaResponse } from "@/common/types/metaResponse";
import { keepPreviousData, useQuery } from "@tanstack/react-query";

type UseEstablishmentAllowedClientCompaniesProps<T> = {
  id?: string,
  mapper?: (data: any) => T,
  enabled?: boolean;
};

export const useEstablishmentAllowedClientCompanies = <T,>({
  id,
  mapper = Mapper.default<T>(),
  enabled = true,
}: UseEstablishmentAllowedClientCompaniesProps<T>) => {
  const privateAxios = usePrivateAxios()

  const {
    data: { data, meta } = defaultTransformerResponse<T>(),
    isPending,
    ...rest
  } = useQuery({
    queryKey: [
      'establishmentAllowedClientCompanies',
      id,
    ],
    queryFn: () => {
      return privateAxios.get(`/establishment/companies/${id}/allowed_client_companies`);
    },
    select: (data: { data: { data: any[], meta: MetaResponse; }; }) => {
      return {
        data: mapper(data?.data?.data),
        meta: data?.data?.meta,
      };
    },
    placeholderData: keepPreviousData,
    enabled,
  });

  return { data, meta, isPending, ...rest };
};
